import { defineMessages } from 'react-intl';

const upgradeAgendaViewMessages = defineMessages({
  featureName: {
    id: 'unlock.agendaView',
    defaultMessage: 'Agenda View',
  },

  featureHeading: {
    id: 'unlock.agendaView.heading',
    defaultMessage: 'Unlock Agenda View',
  },
  featureSummary: {
    id: 'unlock.agendaView.summary',
    defaultMessage: 'See key appointment details at a glance',
  },
  featureUnlockDetails: {
    id: 'unlock.agendaView.details',
    // eslint-disable-next-line max-len
    defaultMessage: 'Agenda View allows you to see pertinent details for visits and fairs scheduled within a specified date range. Quickly and easily view your schedule at a glance.',
  },
});

export default upgradeAgendaViewMessages;
